var _g, _rect, _rect2, _circle, _circle2, _g2, _rect3, _circle3, _circle4, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 157,
    viewBox: "0 0 494 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11388_17613)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.4707,
    y: 18.5703,
    width: 384.962,
    height: 65.9936,
    rx: 10.9989,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.5664,
    y: 32.8672,
    width: 274.973,
    height: 13.1987,
    rx: 5.49946,
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.8662,
    y: 54.8672,
    width: 131.987,
    height: 13.1987,
    rx: 5.49946,
    fill: "#E6E6E6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5687,
    cy: 51.5687,
    r: 15.3985,
    fill: "#D9D9D9",
    stroke: "#7C5C8A",
    strokeWidth: 2.19978
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5688,
    cy: 51.5659,
    r: 12.0988,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 2.19978
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11388_17613)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.2646,
    y: 63.6641,
    width: 384.962,
    height: 65.9936,
    rx: 10.9989,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.36,
    y: 77.9609,
    width: 274.973,
    height: 13.1987,
    rx: 5.49946,
    fill: "#E6E6E6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.363,
    cy: 96.6625,
    r: 15.3985,
    fill: "#D9D9D9",
    stroke: "#FFAC33",
    strokeWidth: 2.19978
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.363,
    cy: 96.6597,
    r: 12.0988,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 2.19978
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 134.66,
    y: 99.9609,
    width: 131.987,
    height: 13.1987,
    rx: 5.49946,
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11388_17613",
    x: 0.472851,
    y: 0.97203,
    width: 428.959,
    height: 109.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.39957
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9989
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11388_17613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11388_17613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11388_17613",
    x: 64.2668,
    y: 46.0658,
    width: 428.958,
    height: 109.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.39957
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9989
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11388_17613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11388_17613",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.6b539b5ab82fdb7f052a779b2cf7225b.svg";
export { ForwardRef as ReactComponent };